<template>
  <section>
    <div class="ir-sub-menu">
      <ul class="col3">
        <li>
          <a href="/ir/governance">コーポレート・ガバナンス</a>
        </li>
        <li>
          <a href="/ir/business">事業内容</a>
        </li>
        <li>
          <a href="/ir/disclosure_policy" class="selected">
            ディスクロージャー
            <br class="sp" />ポリシー
          </a>
        </li>
      </ul>
    </div>

    <div class="l-service">
      <div class="l-service-header">
        <h2 class="heading-default heading-default-center">
          ディスクロージャーポリシー
        </h2>
        <h3 class="heading-small heading-small-center heading-small-mt-sp">
          DISCLOSURE POLICY
        </h3>

        <div class="l-service-content-inner">
          <h2 class="heading-coating heading-coating-small">
            情報開示の基本方針
          </h2>
          <p class="sentence sentence-ir-mb">
            株式会社旅工房（以下、当社）は、金融商品取引法その他の諸法令及び東京証券取引所の定める適時開示規則に従い、情報開示を行います。また、投資家の皆様に当社を理解していただくうえで有用と判断した情報については、できる限り積極的かつ公平に開示することを基本方針としています。
          </p>

          <h2 class="heading-coating heading-coating-small">情報開示の方法</h2>
          <p class="sentence sentence-ir-mb">
            適時開示規則に該当する情報の開示は、同規則に従い、同取引所の提供する適時開示情報伝達システム（TDnet）にて公開します。TDnetにて公開した情報は、当ウェブサイトに速やかに掲載することとしています。また、適時開示規則に該当しない情報についても、適時開示の趣旨を踏まえ、当ウェブサイトに掲載するなど適切な方法により正確かつ公平に投資家の皆様に伝達されるよう配慮します。
          </p>

          <h2 class="heading-coating heading-coating-small">
            将来の見通しに関して
          </h2>
          <p class="sentence sentence-ir-mb">
            当ウェブサイトに掲載されている情報の中には、当社が開示する業績予想のほか、将来の計画や戦略等に関する記述が含まれている場合がありますが、これらは作成時点で入手可能な情報及び合理的であると判断する一定の前提に基づいており、実際の業績等は、さまざまなリスクや不確定要因により大きく異なる結果になる場合があります。
          </p>

          <h2 class="heading-coating heading-coating-small">
            沈黙期間について
          </h2>
          <p class="sentence sentence-ir-mb">
            当社は、決算（四半期含む）情報の漏洩を防ぎ、公平性を確保するため、決算期日から決算発表日までを沈黙期間とし、この期間中は、決算・業績見通しに関するご質問への回答やコメントを差し控えています。ただし、この期間中であっても、業績予想を大きく外れる見込みが出てきた場合や開示すべき重要事実が発生した場合は、適時開示規則に従い、適宜情報開示を行います。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "ディスクロージャー・ポリシー",
      titleTemplate:
        "ディスクロージャー・ポリシー | 経営方針 | IR情報 | 株式会社 旅工房",
    };
  },
};
</script>
